export const firebaseConfig = {
  apiKey: 'AIzaSyCGy9pJQdwoz0U1ItRD8AljSskOxZ_xZb4',
  authDomain: 'eventroy-4d44c.firebaseapp.com',
  projectId: 'eventroy-4d44c',
  storageBucket: 'eventroy-4d44c.firebasestorage.app',
  messagingSenderId: '1025135517127',
  appId: '1:1025135517127:web:eventroy-planner',
};
